interface IRegister{
    email: string,
    password: string,
    re_password: string,
    telefone: string,
    nome: string,
    sobrenome: string,
    recaptcha: object | undefined,
}

export const instanceOfIRegister = (object: any) : object is IRegister => {
    return 'email' in object &&
            'password' in object &&
            're_password' in object &&
            'telefone' in object &&
            'nome' in object &&
            'sobrenome' in object &&
            'recaptcha' in object
}

export default IRegister